import { FormListEntity } from "./FormListEntity";

export interface FormEntity extends FormListEntity {
  imageName: string;
  isPublic: boolean;
}

export namespace FormEntity {
  export function fromJSON(data: any): FormEntity {
    return {
      id: data.formID,
      name: data.formName,
      description: data.formDescription,
      locationId: data.locationID,
      imageName: data.imageName,
      imageUrl: data.imageUrl,
      isPublic: !data.isBinusianOnly,
      link: data.formUrl,
    };
  }
}
